import React from 'react';
import ToolbarLayout from '../../../../elements/ToolbarLayout';
import FavoriteSession from './FavoriteSession';
import { isSessionSelectionControlsVisible } from './isSessionSelectionControlsVisible';
import JoinSession from './JoinSession';
import LeaveSession from './LeaveSession';
import Participants from './Participants';
import { isParticipantsButtonVisible } from './Participants/isParticipantsButtonVisible';
import styles from './SelectableSessionControls.module.scss';

function SelectableSessionControls(props) {
    const { event, session, onJoin, onLeave } = props;

    if (!event?.joined) return null;
    if (!isSessionSelectionControlsVisible(event, session) && !isParticipantsButtonVisible(event, session)) return null;

    return (
        <ToolbarLayout className={styles.SelectableSessionControls}>
            <Participants event={event} session={session} />
            <LeaveSession event={event} session={session} onClick={onLeave} />
            <JoinSession event={event} session={session} onClick={onJoin} />
            <FavoriteSession event={event} session={session} />
        </ToolbarLayout>
    );
}

export default SelectableSessionControls;
